module.exports = __webpack_public_path__ + "static/foodbankmap-6ca23118e79a85c78e6977573680ad9b.png";